import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogPaper: {
    width: 296
  },
  dialogTitle: {
    padding: "11px 20px",
    "& .MuiTypography-h6": {
      fontWeight: 700
    }
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: "0 16px 16px 16px"
  },
  dialogActions: {
    display: "flex",
    gap: 4,
    justifyContent: "end",
    padding: "12px 16px",
    "& > div": {
      flex: 1,
      display: "flex",
      gap: 4,
      justifyContent: "end"
    }
  },
  dialogCloseButton: {
    position: "absolute",
    top: 8,
    right: 8
  },
  dialogCloseButtonIcon: {
    fontSize: 28
  },
  horseName: {
    fontWeight: 700,
    marginBottom: 5,
    wordBreak: "break-word"
  },
  trainerName: {
    marginBottom: 26,
    wordBreak: "break-word"
  },
  lastExamsIcon: {
    fontSize: 16
  },
  examNotesList: {
    maxHeight: 560,
    overflowY: "auto"
  },
  examNotesContainer: {
    backgroundColor: "#ffffff",
    color: theme.palette.primary.main,
    borderRadius: 2,
    padding: 0
  },
  examNotesListItem: {
    padding: "10px 20px",
    borderTop: "1px solid #e6e6e6",
    wordBreak: "break-word",
    "&:nth-child(even)": {
      backgroundColor: "#fbfbfb"
    }
  },
  examNotesContainerHeader: {
    marginBottom: 8,
    paddingLeft: 20
  },
  examNotesContainerBody: {
    fontSize: 12
  },
  createDateTime: {
    color: theme.palette.text.secondary,
    fontSize: 13
  },
  commentCreator: {
    fontSize: 13
  },
  historyButton: {
    padding: "0 3px",
    color: theme.palette.primary.light,
    marginTop: "-3px"
  }
}));
